export const hrExpensesColumns = [
    {
        headerName: "Expense",
        field: "expense",
        width: 160,
    },
    {
        headerName: "Description",
        field: "description",
        width: 160,
    },
    {
        headerName: "Bill Amount",
        field: "billAmount",
        width: 160
    },
    {
        headerName: "EmployeeName",
        field: "employeeName",
        width: 160,
    },
    {
        headerName: "EmployeeNumber",
        field: "employeeNo",
        width: 160,
    },
    {
        headerName: "EmployeeEmail",
        field: "employeeEmail",
        width: 160
    },
    {
        field: "status",
        headerName: "Status",
        width: 160,
    },
    {
        field: "branchName",
        headerName: "Branch Name",
        width: 130,
    },
    {
        field: "branchLocation",
        headerName: "Branch Loc",
        width: 130,
    },
];